export const DESCRIPTION_EVENTS = [
  "APPROVE_DESCRIPTION",
  "REJECT_DESCRIPTION",
  "APPROVE_PEER_DESCRIPTION",
  "REJECT_PEER_DESCRIPTION"
];

export const PICTURE_EVENTS = [
  "UPDATE_PICTURE_APPROVE",
  "REJECT_PICTURE",
  "APPROVE_PICTURE",
  "UPDATE_PICTURE_REJECT"
];

export const REPORT_EVENTS = ["REPORT_RESOLVE", "REPORT_EMAIL"];

export const TEMPORARY_BAN_EVENTS = [
  "DEACTIVATED_USER_TEMPORARY_BAN",
  "TEMPORARY_BANNED",
  "BANNED",
  "SILENT_BANNED"
];

export const STATUS_EVENTS = [
  "CHANGE_USERNAME",
  "CHANGE_STATUS",
  "RESOLVE_INVESTIGATION_CASE",
  "WARN"
];

export const ALWAYS_SHOW_EXTRA_DATA_EVENTS = [
  "BANNED",
  "SILENT_BANNED",
  "WARN",
  "TEMPORARY_BANNED",
  "DEACTIVATED_USER_TEMPORARY_BAN"
];
